import { render, staticRenderFns } from "./ExamplesSection.vue?vue&type=template&id=b3bcb8a8"
import script from "./ExamplesSection.vue?vue&type=script&lang=js"
export * from "./ExamplesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports